import React from 'react'

function HistoricalData() {
  return (
    <div>historical-data</div>
  )
}

export default HistoricalData